(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Free shipping progress bar.
  // The bar is rendered server-side from Liquid and is correct on first paint.
  // Horizon re-renders the cart-drawer section on add/remove/qty change via the
  // Section Rendering API, so the Liquid recomputes automatically. This script is
  // a defensive enhancement: it re-syncs the fill + message from data-total in case
  // only part of the drawer is patched, and animates the fill on open.
  (function () {
    var THRESHOLD_FALLBACK = 15000; // £150 in pennies

    function formatMoney(pennies) {
      var fmt = (window.Shopify && Shopify.money_format) || '\u00a3{{amount}}';
      var amount = (pennies / 100).toFixed(2);
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(pennies / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(pennies / 100));
    }

    function sync(bar, total) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || THRESHOLD_FALLBACK;
      if (typeof total !== 'number') {
        total = parseInt(bar.getAttribute('data-total'), 10) || 0;
      }
      bar.setAttribute('data-total', total);

      var remaining = threshold - total;
      var pct = Math.min(100, Math.round((total / threshold) * 100));

      var fill = bar.querySelector('[data-fsb-fill]');
      var msg = bar.querySelector('[data-fsb-msg]');
      var track = bar.querySelector('.tss-fsb__track');

      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('tss-fsb__fill--done', remaining <= 0);
      }
      if (track) track.setAttribute('aria-valuenow', pct);
      if (msg) {
        if (remaining > 0) {
          msg.innerHTML = 'Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong>free UK shipping</strong>';
        } else {
          msg.innerHTML = '<strong>You have unlocked free UK shipping</strong>';
        }
      }
    }

    if (!customElements.get('free-shipping-bar')) {
      customElements.define('free-shipping-bar', class extends HTMLElement {
        connectedCallback() {
          // Re-sync from the server-rendered data-total on connect (also animates fill).
          var self = this;
          requestAnimationFrame(function () { sync(self); });
        }
      });
    }

    // Fetch the authoritative cart total after any cart change and update every bar.
    function refreshFromCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
            sync(bar, cart.total_price);
          });
        })
        .catch(function () {});
    }

    // Horizon dispatches cart update events; listen broadly so we catch them.
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, refreshFromCart);
    });

    // ===== CART UPSELL / RECOMMENDATIONS =====
    function renderRecs(el, products, cartIds) {
      var row = el.querySelector('[data-rec-row]');
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
      if (!row) return;

      // Filter out anything already in the cart, then cap to the limit.
      var list = products.filter(function (p) {
        return cartIds.indexOf(p.id) === -1;
      }).slice(0, limit);

      if (!list.length) { el.hidden = true; return; }

      row.innerHTML = list.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? p.featured_image.url
          : (p.images && p.images.length ? p.images[0] : '');
        var imgTag = img
          ? '<img src="' + img + '&width=150" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
          : '';
        var price = formatMoney(p.price);
        var brand = p.vendor ? '<p class="tss-rec__brand">' + p.vendor + '</p>' : '';
        return (
          '<a class="tss-rec__card" href="' + p.url + '">' +
            '<span class="tss-rec__imgwrap">' + imgTag + '</span>' +
            '<span class="tss-rec__info">' +
              brand +
              '<p class="tss-rec__name">' + p.title + '</p>' +
              '<p class="tss-rec__price">' + price + '</p>' +
              '<span class="tss-rec__btn">View sizes</span>' +
            '</span>' +
          '</a>'
        );
      }).join('');

      el.hidden = false;
    }

    function loadRecs() {
      var el = document.querySelector('cart-recommendations');
      if (!el) return;

      // Get the current cart to (a) find a seed product and (b) exclude cart items.
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) { el.hidden = true; return; }

          var cartProductIds = cart.items.map(function (i) { return i.product_id; });
          var seed = cart.items[0].product_id;
          var base = el.getAttribute('data-url') || '/recommendations/products';
          var limit = parseInt(el.getAttribute('data-limit'), 10) || 4;
          // Ask for a couple extra so we still fill the row after removing cart items.
          var url = base + '.json?product_id=' + seed + '&limit=' + (limit + 4) + '&intent=related';

          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data && data.products) {
                renderRecs(el, data.products, cartProductIds);
              } else {
                el.hidden = true;
              }
            })
            .catch(function () { el.hidden = true; });
        })
        .catch(function () { el.hidden = true; });
    }

    if (!customElements.get('cart-recommendations')) {
      customElements.define('cart-recommendations', class extends HTMLElement {
        connectedCallback() {
          var self = this;
          requestAnimationFrame(function () { loadRecs(); });
        }
      });
    }

    // Refresh recommendations after any cart change (item removed, added, qty).
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, loadRecs);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
